import { BCMSDate, BCMSRecord, BCMSStateManagerCRUD, useBCMSContext } from "@bcm-dev/bcms-vite";
import OneTimeACHPaymentPage, { getDefaultData, getDefaultUI } from "components/pages/OneTimeACHPaymentPage";
import Classes, { ACHBatch } from "model";

export default function CaptureCompanySelected(props) {
    const context = useBCMSContext();
    BCMSRecord.globalControllerFor(Classes, context);
    const effectiveDate = BCMSDate.init().nextBusinessDay().nextBusinessDay();
    const secCode = ACHBatch.getSelectedSecCodeByBranding();
    const data = BCMSStateManagerCRUD.init(getDefaultData())
    .update([ "oneTimeACHPayment", "transactionType" ], "payment")
    .update([ "oneTimeACHPayment", "secCode" ], secCode)
    .update([ "oneTimeACHPayment", "scheduleType" ], "future dated")
    .update([ "oneTimeACHPayment", "effectiveDate" ], effectiveDate)
    .update([ "oneTimeACHPayment", "companyEntryDescription" ], "ACH PMT")
    .update([ "oneTimeACHPayment", "company" ], "0")
    .submit();

    const ui = BCMSStateManagerCRUD.init(getDefaultUI())
    .update([ "showOneTimeACHModal", "isActive" ], false)
    .update([ "showSecCode", "isActive" ], true)
    .submit();

    return <OneTimeACHPaymentPage data={ data } ui={ ui } />;
}